// extracted by mini-css-extract-plugin
module.exports = {"job__card":"SingleJobCard_job__card__3ajzZ","h5":"SingleJobCard_h5__qOE0Z"};